import { forwardRef, type Ref, type SVGProps } from "react";
const IconAttachmentOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 29.5c-3.86 0-7-3.14-7-7v-12c0-.55.45-1 1-1s1 .45 1 1v12c0 2.76 2.24 5 5 5s5-2.24 5-5v-15c0-1.65-1.35-3-3-3s-3 1.35-3 3v12c0 .55.45 1 1 1s1-.45 1-1v-9c0-.55.45-1 1-1s1 .45 1 1v9c0 1.65-1.35 3-3 3s-3-1.35-3-3v-12c0-2.76 2.24-5 5-5s5 2.24 5 5v15c0 3.86-3.14 7-7 7" />
  </svg>
);
const ForwardRef = forwardRef(IconAttachmentOutlineSVG);
ForwardRef.displayName = "IconAttachmentOutline";
export { ForwardRef as IconAttachmentOutline };
